<img
  src="/assets/massimo/images/x_button.png"
  alt="X"
  class="w-[32px] h-[32px] md:w-[40px] md:h-[40px] cursor-pointer select-none"
/>
